// AUTO-GENERATED at build time by scripts/stamp-version.js. Do not edit.
// The checked-in value is used for local development; CI overwrites it with
// the git tag (e.g. on a `build:release` pipeline) before `ng build`.
export const I18N_VERSION = '0ff0604a';
